// Depends
import { route, group, subGroup, meta } from '@/helpers/routes'

import Index from './index/index'
import Details from './details/index'

const meetingRoutes = [
  route('index', '/index', Index, meta('Lista de Assembléias', true, 'guest')),
  route('details', '/:id/details', Details, meta('Assembléia Detalhes', true, 'guest'))
]

export default [
  ...group('/app', [
    ...subGroup('/meetings', meetingRoutes)
  ])
]



// WEBPACK FOOTER //
// ./src/app/dweller/meeting/routes.js